import { bindContributionProvider, createContributionProvider } from "../../../common/contribution-provider";

import { isBindingContextLoaded } from "../../../common/module-guard";

import { DefaultBaseInteractiveRenderContribution } from "./contributions";

import { ImageRenderContribution } from "./contributions/constants";

import { DefaultCanvasImageRender } from "./image-render";

import { GraphicRender, ImageRender } from "./symbol";

const loadedImageModuleContexts = new WeakSet;

export function bindImageRenderModule({bind: bind}) {
    isBindingContextLoaded(loadedImageModuleContexts, bind) || (bind(ImageRender).toDynamicValue((({container: container}) => new DefaultCanvasImageRender(createContributionProvider(ImageRenderContribution, container)))).inSingletonScope(), 
    bind(GraphicRender).toService(ImageRender), bind(ImageRenderContribution).toService(DefaultBaseInteractiveRenderContribution), 
    bindContributionProvider(bind, ImageRenderContribution));
}

export const imageModule = bindImageRenderModule;
//# sourceMappingURL=image-module.js.map
